import Head from 'next/head';
import Header from '../../components/smm-parts/header';
import React, { useRef, useState } from 'react';
const InstaContent = dynamic(() => import('../social-media-marketing/parts/insta'));

import LazyLoad from 'react-lazyload';
import ViewMore from '../../components/ViewMore';
import dynamic from 'next/dynamic';
import Contact from '../../components/smm-parts/contacct';
import Faq from '../../components/Faq';
import Image from 'next/image';
import CustomProposalWithoutPlatform from '../../components/smm/CustomProposalWithoutPlatform';
import SchedulaACall from '../../components/Base/SchedulaACall';

const InstagramMarketingServices = props => {
  const [platform, setPlatform] = useState('');
  const [step, setStep] = useState(1);
  const [showSMMCustomProposalWithoutPlatformModal, setShowSMMCustomProposalWithoutPlatformModal] = useState(false);

  const showSMMCustomProposalWithoutPlatform = platform => {
    if (props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/custom-proposal?p=' + platform;
    } else {
      setStep(1);
      setShowSMMCustomProposalWithoutPlatformModal(true);
      setPlatform(platform);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  const hideSMMCustomProposalWithoutPlatformModal = () => {
    setStep(1);
    setShowSMMCustomProposalWithoutPlatformModal(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };

  const Ref = useRef();
  const scrollTo = ref => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <Head>
        <title>SMM Services - Instagram Marketing Services | Prodigi</title>
        <meta
          name="description"
          content="Increase your brand's visibility with Prodigi's Instagram marketing services. Create engaging content to engage and grow your audience."
        />
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta property="og:url" content="https://weprodigi.com/instagram-marketing-services" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="SMM Services - Instagram Marketing Services | Prodigi" />
        <meta
          property="og:description"
          content=" Increase your brand's visibility with Prodigi's Instagram marketing services. Create engaging content to engage and grow your audience."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/smm-parts/insta/meta.jpg" />
      </Head>
      <style jsx global>{`
        .jello-horizontal {
          animation: slide1 1s ease-in-out infinite;
          // margin-left: 9px;
        }
        @keyframes slide1 {
          0%,
          100% {
            transform: translate(0, 0);
          }

          50% {
            transform: translate(10px, 0);
          }
        }
        .vector1 {
          opacity: 0;
          animation: vector 1s infinite;
          animation-delay: 100ms;
        }
        .vector2 {
          opacity: 0;
          animation: vector 1s infinite;
          animation-delay: 200ms;
        }
        .vector3 {
          opacity: 0;
          animation: vector 1s infinite;
          animation-delay: 400ms;
        }
        @keyframes vector {
          0% {
            opacity: 0.9;
          }
          5% {
            opactiy: 1;
          }
          6% {
            opactiy: 0.1;
          }
          100% {
            opactiy: 0.1;
          }
        }
        @media screen and (max-width: 1440px) {
          .text-part {
            padding-left: 20px !important;
          }
          .big-text-green {
            font-size: 40px;
            line-height: 40px;
          }
          .fix-elem {
            height: 550px !important;
            // min-height:unset
          }
          .text-part {
            display: block;
            margin-top: 40px;
          }
        }
        @media screen and (max-width: 780px) {
          .lg:w-40p,
          .lg:w-60p {
            width: 100%;
          }
        }
        @media screen and (max-width: 700px) {
          .big-text-green {
            font-size: 30px;
            line-height: 30px;
          }
          .small-text {
            font-size: 18px;
            line-height: 20px;
            width: 200px;
            overflow: visible;
          }
          .phone {
            top: 90px;
            left: 33px;
          }
          .fix-elem {
            height: 350px !important;
            min-height: unset;
          }
          .text-part {
            margin-top: 10px;
          }
        }

        @keyframes wave {
          00% {
            transform: translateY(0em);
          }
          60% {
            transform: translateY(-0.6em);
          }
          100% {
            transform: translateY(0em);
          }
        }
        @media screen and (min-width: 768px) and (max-width: 1100px) {
          .fb-animation-text {
            font-size: 5vw !important;
          }
          .insta-animation-text {
            font-size: 4.5vw !important;
          }
          .linkedin-animation-text {
            font-size: 5.5vw !important;
          }
          .snapchat-animation-text {
            font-size: 5vw !important;
          }
          .twitter-animation-text {
            font-size: 6vw !important;
          }
        }
        @media screen and (max-width: 768px) {
          .fb-animation-text {
            font-size: 6vw !important;
          }
          .insta-animation-text {
            font-size: 5vw !important;
          }
          .linkedin-animation-text {
            font-size: 6.5vw !important;
          }
          .snapchat-animation-text {
            font-size: 6vw !important;
          }
          .twitter-animation-text {
            font-size: 7.5vw !important;
          }
        }
      `}</style>
      <Header
        width={props.width}
        country={props.country}
        platform={'Instagram'}
        url={'https://weprodigi.com/uploads/images/smm-parts/insta/header_insta.mp4'}
        service={'instagram'}
      />
      <LazyLoad height={400} once>
        <div className="bg-white">
          <div className="container">
            <div className="grid md:hidden grid-cols-12 py-23">
              <div className="col-span-6">
                <p className="text-purple text-24 md:text-48 font-black uppercase mb-23 leading-tight">
                  Instagram<br></br>marketing
                </p>
              </div>
              <div className="col-span-1 md:col-span-2" />
              <div className="col-span-5 md:col-span-4">
                <div className="relative flex items-center mb-30">
                  <div className="realtive z-10">
                    <Image src="/images/smm/insta.png" width="352" height="111" layout="intrinsic" alt="instagram" />
                  </div>
                  <p className="absolute font-black insta-animation-text" style={{ fontSize: '54px', color: 'rgba(38, 38, 40, 0.04)' }}>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.0s',
                      }}
                    >
                      I
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.1s',
                      }}
                    >
                      N
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.2s',
                      }}
                    >
                      S
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.3s',
                      }}
                    >
                      T
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.4s',
                      }}
                    >
                      A
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.5s',
                      }}
                    >
                      G
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.6s',
                      }}
                    >
                      R
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.7s',
                      }}
                    >
                      A
                    </span>
                    <span
                      className="inline-block"
                      style={{
                        animation: 'wave 1.4s ease-in-out infinite',
                        animationDelay: '0.8s',
                      }}
                    >
                      M
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className={'flex md:hidden  justify-between flex-col-reverse md:flex-row'}>
              <div className="w-full md:w-40p max-w-380 bg-transparent md:bg-red-smm py-0 md:py-24 px-0 md:px-26 self-start mt-0 md:mt-5">
                <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                  Instagram Marketing
                </h2>
                <div className="flex mt-0  md:mt-15 font-normal  text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>12 posts creatives</span>
                </div>
                <div className="flex mt-5 font-normal  text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>8 custom-designed visuals(images)</span>
                </div>
                <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>4 reels </span>
                </div>
                <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>2 boosted posts</span>
                </div>
                <div
                  className="mt-15 pb-20 md:pb-0  flex text-green-badge text-20 leading-24 font-medium cursor-pointer items-center"
                  onClick={() => {
                    scrollTo(Ref);
                  }}
                >
                  See Full Deliverables
                  <p className="jello-horizontal">
                    {' '}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </p>
                </div>

                <div className="mt-23  flex items-center justify-center">
                  <button
                    onClick={() => showSMMCustomProposalWithoutPlatform('instagram')}
                    className={
                      'bg-green-badge w-full hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                    }
                  >
                    Get a Proposal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white py-23 pb-23 relative">
          <div className="container">
            <div className="flex justify-between flex-col-reverse md:flex-row">
              <div className="w-full md:w-50p mt-0 ">
                <p className="text-black text-16 hidden md:block">
                  Indeed, all businesses should have a public presence on Instagram, however there are industries for which this is an absolute
                  necessity: HoReCa, clothing and accessories, beauty products and services, Health and sports.<br></br>
                  In terms of its capabilities, Instagram now and again outperforms other social media platforms. Here, in addition to beautiful
                  visual content, users are provided with interactive stories, camera filters, videos of industry influencers, reels with helpful
                  tips, interesting giveaways, etc. All this creates additional value for the user and further contributes to increased engagement
                  with the brand.<br></br>
                  We will create content that will help capture the desired outcomes, create a competitive advantage and capture users' attention. All
                  this is possible because WeProdigi, unlike many other digital agencies, has a separate creative and production department that
                  specializes in creating unique and effective visual assets.
                </p>
                <div className="block md:hidden">
                  <ViewMore ln={20}>
                    Indeed, all businesses should have a public presence on Instagram, however there are industries for which this is an absolute
                    necessity: HoReCa, clothing and accessories, beauty products and services, Health and sports.<br></br>
                    In terms of its capabilities, Instagram now and again outperforms other social media platforms. Here, in addition to beautiful
                    visual content, users are provided with interactive stories, camera filters, videos of industry influencers, reels with helpful
                    tips, interesting giveaways, etc. All this creates additional value for the user and further contributes to increased engagement
                    with the brand.<br></br>
                    We will create content that will help capture the desired outcomes, create a competitive advantage and capture users' attention.
                    All this is possible because WeProdigi, unlike many other digital agencies, has a separate creative and production department that
                    specializes in creating unique and effective visual assets.
                  </ViewMore>
                </div>
              </div>
              {/*<div className="hidden md:block col-span-2 order-2"/>*/}
              <div className="hidden md:block w-full md:w-40p max-w-380 bg-transparent md:bg-red-smm py-0 md:py-24 px-0 md:px-26 self-start mt-0 md:mt-5">
                <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                  Instagram Marketing
                </h2>
                <div className="flex mt-0  md:mt-15 font-normal  text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>12 posts creatives</span>
                </div>
                <div className="flex mt-5 font-normal  text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>8 custom-designed visuals(images)</span>
                </div>
                <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>4 reels </span>
                </div>
                <div className="flex mt-5 font-normal text-16 leading-20 items-start">
                  <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                  <span className={'ml-15'}>2 boosted posts</span>
                </div>
                <div
                  className="mt-15 pb-20 md:pb-0 flex text-green-badge text-20 leading-24 font-medium cursor-pointer items-center"
                  onClick={() => {
                    scrollTo(Ref);
                  }}
                >
                  See Full Deliverables
                  <p className="jello-horizontal">
                    {' '}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </p>
                </div>
                <div className="mt-23  flex items-center justify-center relative">
                  <button
                    onClick={() => showSMMCustomProposalWithoutPlatform('instagram')}
                    className={
                      'bg-green-badge w-full hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                    }
                  >
                    Get a Proposal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <InstaContent refProp={Ref} />
        <LazyLoad height={0} once>
          <Contact
            width={props.width}
            platform={'Instagram'}
            platforms={'Instagram'}
            country={props.country}
            title="CALCULATE YOUR Instagram MARKETING COST"
            description={'Answer five questions and get to know the price!'}
            image={'https://weprodigi.com/uploads/images/smm-parts/insta/Ani.png'}
          />
        </LazyLoad>
      </LazyLoad>
      <LazyLoad height={0} once>
        <div className="bg-white">
          <div className="container py-23">
            <h3 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h3>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Do you guarantee sales?',
                    answer:
                      "Nobody can ensure sales for your business, because professional SMM services are intended to help businesses succeed on Social Media and this indirectly impacts on generating sales. Furthermore, as an experienced agency, we can guarantee traffic to your website, brand awareness, and engagement, but we can't guarantee increased sales. We'll use our industry expertise to manage your social media efforts, but it's ultimately up to you to satisfy your target audience and encourage sales.",
                  },
                  {
                    title: 'Can I pre-approve the posts before they go live?',
                    answer:
                      'We will send you fortnightly content to approve and request amends before it’s due to go live the week after. That way, you can always see what we have lined up, make any changes, or request design modifications beforehand. ',
                  },
                  {
                    title: 'How do you get information about-us-new my target?',
                    answer:
                      'At the very beginning of the cooperation, we send a questionnaire, where the client fills in information about-us-new the business and the target audience. In addition, we use analytic tools that permit us to accumulate information about-us-new the target audience and build future activities dependent on it. This is all about-us-new personalized service.',
                  },
                  {
                    title: "What if my business doesn't have Social Media accounts?",
                    answer:
                      'In case of cooperation with us, we create and set up social media pages free of any charges, and you will have complete ownership of those accounts as well.',
                  },
                  {
                    title: 'What days of the week will you post on?',
                    answer:
                      'Although we create your posts and design your content calendar during the working week, they will be scheduled to go live on the days we agree. We will consistently look at your social media insights on each platform to see when your followers are most active to recommend optimum days and times to post.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How long does it take to have the first social media post published?',
                    answer: (
                      <>
                        On average, our usual preparation process requires from five to seven business days. But if you have a set deadline, we always
                        try to offer custom solutions without any extra fees.<br></br>During this period, our specialists do research and collect
                        information about your business, based on which the content is created and presented to you.
                      </>
                    ),
                  },
                  {
                    title: 'How much involvement will I have?',
                    answer:
                      'It is totally up to you. We have created a management process where everything is done to save your time. Simultaneously, you can be integrated into every process of our cooperation and hold discussions and brainstorming with us.',
                  },
                  {
                    title: 'What about payment?',
                    answer:
                      'Billing is carried out in 2 milestones: the first one after the first week of collaboration, and the other part at the end of the month. Kindly note that the research part is not included in the first working week, hence,  the one-month period starts from the day we send you the content of the first week.',
                  },
                  {
                    title: 'Do I have benefits if I order SMM services on more than 1 platform?',
                    answer:
                      'Yes. You do not have to pay the same price for each platform separately as we create a package that includes full service on the platforms of your choice, and you pay less for each platform that will be added as well.',
                  },
                  {
                    title: 'Can I use social media videos on my website?',
                    answer:
                      'Yes. The social media videos we create can be used both on the website and for different purposes. We are happy to help our partners to achieve their business goals.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>
      <SchedulaACall
        country={props.country}
        width={props.width}
        url="https://calendar.app.google/uJZkJfztLwHZcfkC7"
      />

      {/*<LazyLoad height={200}  once>*/}

      {/*     <div className="bg-white bg-grid ">*/}
      {/*        <div className="relative">*/}
      {/*            <div className="flex flex-col md:flex-row items-end">*/}
      {/*                <div*/}
      {/*                    className="bg-fixed fix-elem items-end w-full  lg:w-40p bg-purple bg-center bg-cover h-650 min-h-650 relative"*/}
      {/*                    style={{'backgroundImage': `url(https://weprodigi.com/uploads/images/smm/texture.png)`}}>*/}
      {/*                    <div className={'absolute right-0 md:-right-150 bottom-0 z-50'}>*/}
      {/*                        <picture>*/}
      {/*                            <source media="(min-width:768px)" srcSet="/images/smm/Luso_smm.webp"*/}
      {/*                                    type="image/webp"/>*/}
      {/*                            <source media="(min-width:768px)" srcSet="/images/smm/Luso_smm.png"*/}
      {/*                                    type="image/png"/>*/}
      {/*                            <source media="(max-width:768px)" srcSet="https://weprodigi.com/uploads/images/smm/Luso_smm_mobile.png"*/}
      {/*                                    type="image/png"/>*/}
      {/*                            <img width={props.width < 768 ? 256 : 307}*/}
      {/*                                 height={props.width < 768 ? 236 : 482} src="" className='hide'*/}
      {/*                                 alt={'personage  lusi'}/>*/}
      {/*                        </picture>*/}
      {/*                        <div className="phone absolute top-130 w-57 h-57 left-45"*/}
      {/*                             style={{'backgroundImage': `url(/images/smm/phone.svg)`}}>*/}
      {/*                            <div className="vector1 w-8 h-8 absolute top-20 left-30"*/}
      {/*                                 style={{'backgroundImage': `url(/images/smm/vector1.png)`}}/>*/}
      {/*                            <div className="vector2 w-14 h-14 absolute top-12 left-32"*/}
      {/*                                 style={{'backgroundImage': `url(/images/smm/vector2.png)`}}/>*/}
      {/*                            <div className="vector3 w-20 h-20 absolute top-0 left-36"*/}
      {/*                                 style={{'backgroundImage': `url(/images/smm/vector3.png)`}}/>*/}

      {/*                        </div>*/}
      {/*                    </div>*/}
      {/*                    <div*/}
      {/*                        className='text-white text-part w-full  pl-15 sm:pl-20 md:pl-100 xl:pl-150   h-full absolute pb-200 block md:flex flex-col justify-center items-start'>*/}
      {/*                        <div*/}
      {/*                            className={'font-800 big-text-green text-green text-24 md:text-36 xl:text-72  uppercase leading-5 md:leading-88 pr-20 mt-20 md:mt-0 '}>Schedule*/}
      {/*                            a*/}
      {/*                            call*/}
      {/*                        </div>*/}
      {/*                        <div*/}
      {/*                            className={'font-normal small-text text-24 text-left leading-29 text-29 mt-15 pr-20'}>with*/}
      {/*                            our Account*/}
      {/*                        </div>*/}
      {/*                        <div*/}
      {/*                            className={'font-normal small-text text-24 text-left leading-29 text-29 mt-29 pr-20'}>Management*/}
      {/*                            Director*/}
      {/*                        </div>*/}
      {/*                    </div>*/}
      {/*                </div>*/}
      {/*                <div className="w-full lg:w-60p min-h-650 flex justify-center items-center ">*/}
      {/*                    <LazyLoad >*/}
      {/*                        <div*/}
      {/*                            className="calendly-inline-widget min-w-320 md:min-w-500 w-80p min-h-400 md:min-h-650 h-500 md:h-650 m-auto"*/}
      {/*                            data-url="https://calendar.app.google/uJZkJfztLwHZcfkC7"*/}
      {/*                        >*/}
      {/*                            <iframe title={"calendly"}*/}
      {/*                                    src="https://calendar.app.google/uJZkJfztLwHZcfkC7"*/}
      {/*                                    frameBorder="0"*/}
      {/*                                    width={props.width < 768 ? '100%' : '110%'}*/}
      {/*                                    height={'100%'}*/}
      {/*                            />*/}
      {/*                        </div>*/}
      {/*                    </LazyLoad>*/}
      {/*                </div>*/}
      {/*            </div>*/}
      {/*        </div>*/}
      {/*    </div>*/}
      {/*</LazyLoad>*/}
      <CustomProposalWithoutPlatform
        step={step}
        country={props.country}
        platform={platform}
        show={showSMMCustomProposalWithoutPlatformModal}
        title="Get SMM Pricing"
        hide={hideSMMCustomProposalWithoutPlatformModal}
      />
    </>
  );
};
export default InstagramMarketingServices;
